import React from 'react'
import {
    Paper,
    TableCell,
    TableContainer,
    TableHead,
    Table as MuiTable,
    TableBody,
    TableRow,
} from '@mui/material'
import {darken, lighten} from 'polished'
import styled from 'styled-components'

const Table = ({columns, rows, onRowClick, height}) => {
    return (
        <StyledTableContainer component={StyledPaper} height={height}>
            <StyledTable>
                <StyledTableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <StyledTableCell key={column.id}>
                                {column.label}
                            </StyledTableCell>
                        ))}
                    </TableRow>
                </StyledTableHead>
                {rows && (
                    <TableBody>
                        {rows.map((row) => (
                            <StyledTableRow
                                key={row._id}
                                onClick={() => onRowClick(row)}>
                                {columns.map((column) => (
                                    <StyledTableCell key={column.id}>
                                        {row[column.id]}
                                    </StyledTableCell>
                                ))}
                            </StyledTableRow>
                        ))}
                    </TableBody>
                )}
            </StyledTable>
        </StyledTableContainer>
    )
}

export default Table

const StyledPaper = styled(Paper)`
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    /* overflow: hidden; */
`

const StyledTableContainer = styled(TableContainer)`
    width: 100%;
    height: ${({height}) => height};
`

const StyledTableHead = styled(TableHead)`
    background-color: ${darken(0.1, '#f0f0f0')};
    position: sticky;
    top: 0;
    z-index: 10;
`

const StyledTableCell = styled(TableCell)`
    width: 16%;
    font-weight: bold;
    text-align: left;
    padding: 16px;
`

const StyledTableRow = styled(TableRow)`
    /* &:nth-of-type(even) {
        background-color: ${lighten(0.015, '#f0f0f0')};
    } */
    cursor: pointer;
    &:hover {
        background-color: ${lighten(0.015, '#f0f0f0')};
    }
`
const StyledTable = styled(MuiTable)`
    min-width: 650px;
    width: 100%;
`
